import React, { useRef } from 'react';
import styled from 'styled-components';

import { useModal } from '../../../Providers/ModalContext';
import Modal from '../../../Global/Modal';
import RichText from '../../../Global/RichText';
import TwoColumns from '../../../Global/Grid/TwoColumns';

import CloseIcon from '../../../../Images/icons/close-icon.png';
import TorresBg from '../../../../Images/background/bg_camp-torres.png';
import LogoStudio from '../../../../Images/logos/logo-studio.png';

import {
  Torres_Title,
  Title_Video,
  Title_Video_2,
  Title_Video_3,
  Title_4,
  Torres_Gallery,
} from '../../../../utils/ES/Modals/campTorres';

const breakpoints = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1440px',
};

const CloseContainer = styled.div`
  padding: 10px;
  position: absolute;
  top: 30px;
  right: 30px;

  @media (max-width: ${breakpoints.mobile}) {
    top: 15px;
    right: 15px;
    width: 60px;
    height: 60px;
  }
`;

const CloseButton = styled.img`
  cursor: pointer;
  width: 64px;
  height: auto;
  transition: all 0.3s ease-out;
  transform-origin: center;

  @media (max-width: ${breakpoints.mobile}) {
    width: 40px;
  }

  &:hover {
    filter: drop-shadow(0px 0px 10px rgba(255, 255, 255, 1))
      drop-shadow(0px 0px 4px rgba(255, 255, 255, 1));
    transform: scale(1.15);
  }
`;

const ModalContent = styled.div`
  width: 100%;
  position: relative;
  padding: 25px 60px;
  display: flex;
  align-items: flex-start;

  flex-direction: column;
  gap: 2.5rem;

  p,
  h2,
  h3 {
    text-transform: uppercase;
  }
`;

const TitleContent = styled.div`
  display: flex;
  align-items: center;
  gap: 3.375rem;

  p {
    text-transform: uppercase;
  }
`;

const LogoContent = styled.div`
  display: block;
  max-width: 276px;
  width: 100%;
  padding: 15px;
  position: relative;

  img {
    display: block;
    width: 100%;
    cursor: pointer;
    transition: all 0.3s ease-out;

    &:hover {
      filter: drop-shadow(0px 0px 20px rgba(250, 115, 19, 1));
    }
  }

  &::after {
    content: '';
    position: absolute;
    width: 12px;
    height: 93px;
    background: #fff;

    top: 0;
    bottom: 0;

    margin: auto;
    right: -10%;
  }
`;

const VideoFrame = styled.iframe`
  width: 100%;
  max-width: 100%;
  height: 594px;
  border: none;

  @media (max-width: ${breakpoints.mobile}) {
    height: 150px;
  }
`;

const ModalTorres = () => {
  const { closeModal } = useModal();

  const iframeRef = useRef(null);

  const handleClose = () => {
    if (iframeRef.current) {
      iframeRef.current.src = iframeRef.current.src;
    }
    closeModal();
  };

  return (
    <>
      <Modal id="campaign-torres" bgImg={TorresBg}>
        <CloseContainer>
          <CloseButton
            onClick={handleClose}
            aria-label="Close modal"
            src={CloseIcon}
          />
        </CloseContainer>
        <ModalContent>
          <TitleContent>
            <LogoContent>
              <img
                src={LogoStudio}
                onClick={handleClose}
                aria-label="Close modal"
                alt="Kuter Studio"
              />
            </LogoContent>
            <RichText dataText={Torres_Title} />
          </TitleContent>
          <RichText dataText={Title_Video} />
          <VideoFrame
            ref={iframeRef}
            src="https://player.vimeo.com/video/134350687"
            allow="autoplay; fullscreen;"
            referrerPolicy="strict-origin-when-cross-origin"
            title="KUTER_STUDIO_TORRES_10"
          />
          <RichText dataText={Title_Video_2} />
          <VideoFrame
            ref={iframeRef}
            src="https://player.vimeo.com/video/134350685"
            allow="autoplay; fullscreen;"
            referrerPolicy="strict-origin-when-cross-origin"
            title="KUTER_STUDIO_TORRES_10"
          />
          <RichText dataText={Title_Video_3} />
          <VideoFrame
            ref={iframeRef}
            src="https://player.vimeo.com/video/134350685"
            allow="autoplay; fullscreen;"
            referrerPolicy="strict-origin-when-cross-origin"
            title="KUTER_STUDIO_TORRES_10"
          />
          <RichText dataText={Title_4} />
          <TwoColumns column={Torres_Gallery} />
        </ModalContent>
      </Modal>
    </>
  );
};

export default ModalTorres;
